import Vue from "vue";
import VueI18n from "vue-i18n";
import store from "@/factories/store.factory";

const translationKeyRegexp = /^[_a-zA-Z-]+\.{1}[^-\s]*$/m;

Vue.use(VueI18n);

const hasTranslationKeyCorrectFormat = key => translationKeyRegexp.test(key);

export default new VueI18n({
  silentTranslationWarn: true,
  missing(locale, translationKey) {
    if (window.location.search.indexOf("no-i18n") !== -1) {
      return;
    }

    if (!hasTranslationKeyCorrectFormat(translationKey)) {
      return;
    }

    setTimeout(
      () =>
        store.dispatch("translations/addMissingTranslation", {
          locale,
          translationKey
        }),
      0
    );
  }
});
